module.exports = __webpack_public_path__ + "00_hair.050aa156.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/00_hair.png
// module id = lG+Y
// module chunks = 0